/* eslint-disable import/no-unresolved */
import { APP_NAME } from "../config-global";


export const PASSING_DATE_FORMAT = "YYYY-MM-DD";

export const SMALL_MODAL = "sm";
export const MEDIUM_MODAL = "md";
export const LARGE_MODAL = "lg";
export const EXTRA_LARGE_MODAL = "xl";

export const DECIMAL_PLACE = 0;
export const API_PAGE_LIMIT = 15;
export const ROW_PER_PAGE_OPTION = [15, 30, 45]

// error code
export const FORCE_PUCNH_IN = 1001;
export const SESSION_EXPIRED = 440;
export const NOT_COMPANY_SET = 111;
export const SA_RESTRICTED = 1000;
export const ADMIN_RESTRICTED = 999;
export const TIMEOUT = "TIMEOUT";
export const INTERNET_NETWORK_ERROR = "Network Error";

export const STORAGE_KEY_USER = "users";
export const STORAGE_KEY_PASSCODE = 1272;

export const COUNTRY_API = "country";
export const STATE_API = "state";

export const ESTIMATE = {
    workorderServiceGroup: "/workorder/getAllStatusWise",
    workorderServiceGroupEstimate: "/workorder_estimate_item_transaction/approveEstimateItems",
    CreatePaymentLink: "/geidea",
    getPaymentDetails: "/geidea/getPaymentDetails",
    getTaxCalculation: "tax_calculation/",
};

export const RATING_REVIEWS = {
    get: "workorder/getRatingsReviewsWorkorderDetails",
    create: "ratings_reviews/createFromCustomer"
}

export const VEHICLE_CLASSIFICATION_TYPE = {
    get: "vehicle_classification_type/getAllCustomerWebsite",
};

export const APPOINTMENT = {
    // get: "appointment/getAppointmentCompanyDetails",
    get: "company/getCompanyWithoutAuth/",
    create: "leads/createLeadsURL",
    customerAppointmentSlot: "appointment/customerAppointmentSlot/"
}



